// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Hfkj","productName":"Table_productName__3uMNN"};